import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { WebCryptoAlgorithmSuite, WebCryptoDefaultCryptographicMaterialsManager, getEncryptHelper, KeyringWebCrypto, needs, CommitmentPolicy, CommitmentPolicySuites, MessageFormat } from '@aws-crypto/material-management-browser';
import { serializeFactory, aadFactory, concatBuffers, serializeSignatureInfo, FRAME_LENGTH, raw2der, Maximum, MessageIdLength, serializeMessageHeaderAuth } from '@aws-crypto/serialize';
import { fromUtf8 } from '@aws-sdk/util-utf8-browser';
import { getWebCryptoBackend } from '@aws-crypto/web-crypto-backend';
var serialize = serializeFactory(fromUtf8);

var _aadFactory = aadFactory(fromUtf8),
    messageAADContentString = _aadFactory.messageAADContentString,
    messageAAD = _aadFactory.messageAAD;

export function _encrypt(_x, _x2, _x3) {
  return _encrypt2.apply(this, arguments);
}

function _encrypt2() {
  _encrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(commitmentPolicy, cmm, plaintext) {
    var _ref,
        suiteId,
        _ref$encryptionContex,
        encryptionContext,
        _ref$frameLength,
        frameLength,
        backend,
        plaintextLength,
        suite,
        encryptionRequest,
        material,
        _yield$getEncryptHelp,
        getEncryptInfo,
        subtleSign,
        dispose,
        versionString,
        messageIdLength,
        messageId,
        ivLength,
        _yield$getEncryptInfo,
        getSubtleEncrypt,
        keyCommitment,
        messageHeader,
        header,
        headerIv,
        headerAuthTag,
        numberOfFrames,
        finalFrameLength,
        bodyContent,
        sequenceNumber,
        frameIv,
        isFinalFrame,
        frameHeader,
        contentString,
        messageAdditionalData,
        framePlaintext,
        cipherBufferAndAuthTag,
        result,
        signatureArrayBuffer,
        derSignature,
        signatureInfo,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, suiteId = _ref.suiteId, _ref$encryptionContex = _ref.encryptionContext, encryptionContext = _ref$encryptionContex === void 0 ? {} : _ref$encryptionContex, _ref$frameLength = _ref.frameLength, frameLength = _ref$frameLength === void 0 ? FRAME_LENGTH : _ref$frameLength;

            /* Precondition: _encrypt needs a valid commitmentPolicy. */
            needs(CommitmentPolicy[commitmentPolicy], 'Invalid commitment policy.');
            /* Precondition: The frameLength must be less than the maximum frame size for browser encryption. */

            needs(frameLength > 0 && Maximum.FRAME_SIZE >= frameLength, "frameLength out of bounds: 0 > frameLength >= ".concat(Maximum.FRAME_SIZE));
            _context.next = 5;
            return getWebCryptoBackend();

          case 5:
            backend = _context.sent;

            if (backend) {
              _context.next = 8;
              break;
            }

            throw new Error('No supported crypto backend');

          case 8:
            /* If the cmm is a Keyring, wrap it with WebCryptoDefaultCryptographicMaterialsManager. */
            cmm = cmm instanceof KeyringWebCrypto ? new WebCryptoDefaultCryptographicMaterialsManager(cmm) : cmm; // Subtle Crypto functions are all one-shot so all the plaintext needs to be available.

            plaintextLength = plaintext.byteLength;
            suite = suiteId && new WebCryptoAlgorithmSuite(suiteId);
            /* Precondition: Only request WebCryptoEncryptionMaterial for algorithm suites supported in commitmentPolicy. */

            CommitmentPolicySuites.isEncryptEnabled(commitmentPolicy, suite);
            encryptionRequest = {
              suite: suite,
              encryptionContext: encryptionContext,
              plaintextLength: plaintextLength,
              commitmentPolicy: commitmentPolicy
            };
            _context.next = 15;
            return cmm.getEncryptionMaterials(encryptionRequest);

          case 15:
            material = _context.sent;

            /* Precondition: Only use WebCryptoEncryptionMaterial for algorithm suites supported in commitmentPolicy. */
            CommitmentPolicySuites.isEncryptEnabled(commitmentPolicy, material.suite);
            _context.next = 19;
            return getEncryptHelper(material);

          case 19:
            _yield$getEncryptHelp = _context.sent;
            getEncryptInfo = _yield$getEncryptHelp.getEncryptInfo;
            subtleSign = _yield$getEncryptHelp.subtleSign;
            dispose = _yield$getEncryptHelp.dispose;
            versionString = MessageFormat[material.suite.messageFormat];
            messageIdLength = parseInt(MessageIdLength[versionString], 10);
            /* Precondition UNTESTED: WebCrypto suites must result is some messageIdLength. */

            needs(messageIdLength > 0, 'Algorithm suite has unknown message format.');
            _context.next = 28;
            return backend.randomValues(messageIdLength);

          case 28:
            messageId = _context.sent;
            ivLength = material.suite.ivLength;
            _context.next = 32;
            return getEncryptInfo(messageId);

          case 32:
            _yield$getEncryptInfo = _context.sent;
            getSubtleEncrypt = _yield$getEncryptInfo.getSubtleEncrypt;
            keyCommitment = _yield$getEncryptInfo.keyCommitment;
            messageHeader = serialize.buildMessageHeader({
              suite: material.suite,
              encryptedDataKeys: material.encryptedDataKeys,
              encryptionContext: material.encryptionContext,
              messageId: messageId,
              frameLength: frameLength,
              suiteData: keyCommitment
            });
            header = serialize.serializeMessageHeader(messageHeader);
            headerIv = serialize.headerAuthIv(ivLength);
            _context.t0 = Uint8Array;
            _context.next = 41;
            return getSubtleEncrypt(headerIv, header)(new Uint8Array(0));

          case 41:
            _context.t1 = _context.sent;
            headerAuthTag = new _context.t0(_context.t1);
            numberOfFrames = Math.ceil(plaintextLength / frameLength);
            /* The final frame has a variable length.
             * The value needs to be known, but should only be calculated once.
             * So I calculate how much of a frame I should have at the end.
             * This value will NEVER be larger than the frameLength.
             */

            finalFrameLength = frameLength - (numberOfFrames * frameLength - plaintextLength);
            bodyContent = [];
            sequenceNumber = 1;

          case 47:
            if (!(numberOfFrames >= sequenceNumber)) {
              _context.next = 61;
              break;
            }

            frameIv = serialize.frameIv(ivLength, sequenceNumber);
            isFinalFrame = sequenceNumber === numberOfFrames;
            frameHeader = isFinalFrame ? serialize.finalFrameHeader(sequenceNumber, frameIv, finalFrameLength) : serialize.frameHeader(sequenceNumber, frameIv);
            contentString = messageAADContentString({
              contentType: messageHeader.contentType,
              isFinalFrame: isFinalFrame
            });
            messageAdditionalData = messageAAD(messageId, contentString, sequenceNumber, isFinalFrame ? finalFrameLength : frameLength);
            /* Slicing an ArrayBuffer in a browser is suboptimal.
             * It makes a copy.s
             * So I just make a new view for the length of the frame.
             */

            framePlaintext = new Uint8Array(plaintext.buffer, (sequenceNumber - 1) * frameLength, isFinalFrame ? finalFrameLength : frameLength);
            _context.next = 56;
            return getSubtleEncrypt(frameIv, messageAdditionalData)(framePlaintext);

          case 56:
            cipherBufferAndAuthTag = _context.sent;
            bodyContent.push(frameHeader, cipherBufferAndAuthTag);

          case 58:
            sequenceNumber += 1;
            _context.next = 47;
            break;

          case 61:
            result = concatBuffers.apply(void 0, [header, serializeMessageHeaderAuth({
              headerIv: headerIv,
              headerAuthTag: headerAuthTag,
              messageHeader: messageHeader
            })].concat(bodyContent));
            dispose();

            if (!(typeof subtleSign === 'function')) {
              _context.next = 72;
              break;
            }

            _context.next = 66;
            return subtleSign(result);

          case 66:
            signatureArrayBuffer = _context.sent;
            derSignature = raw2der(new Uint8Array(signatureArrayBuffer), material.suite);
            signatureInfo = serializeSignatureInfo(derSignature);
            return _context.abrupt("return", {
              result: concatBuffers(result, signatureInfo),
              messageHeader: messageHeader
            });

          case 72:
            return _context.abrupt("return", {
              result: result,
              messageHeader: messageHeader
            });

          case 73:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _encrypt2.apply(this, arguments);
}